import { AnalyticsService } from '../../typescript/common/analytics-service';
import './_artvise-chat.scss';
import { ClientSideStorageService } from '../../react/services/client-side-storage.service';
import { ClientSideStorageType } from '../../react/models/client-side-storage-type.enum';
import { TranslationService } from '../../react/services/translation.service';
import { ConfigurationService } from '../../react/services/configuration.service';

export default class ArtviseChat {
  constructor() {
    if (document.getElementById('artvise-chat')) {
      // Save the onclick event for the chat button so we can use it later if neccessary
      const onclickArtviseChatEvent = () => {
        AnalyticsService.addEvent(AnalyticsService.ExternalLinkAction, 'Klick på chattknapp');
        const url = `https://kundtjanstchattapi${
          ConfigurationService.get('chatinstance') === 'test' ? '-test' : ''
        }.vasttrafik.se/ContactCenter/ChatWindow.aspx?extension=8000&amp;titletext=Chatta%20med%20oss&amp;tabtext=Chatta%20med%20oss`;
        window.open(url, TranslationService.get('common.chatwithus'), 'width=460,height=550,resizable=1');
      };

      const artviseChatBtn = document.getElementById('artvise-chat-btn') as HTMLButtonElement;
      const artviseOnPageChatBtn = document.getElementById('artvise-on-page-chat-block-btn') as HTMLButtonElement;

      const setArtviseClasses = () => {
        document.getElementById('artvise-chat')?.classList.add('artvise-chat', 'd-print-none');
        document.getElementById('artvise-chat')?.classList.remove('d-none');
      };

      const onClickShowQuickCookieConsent = () => {
        document.dispatchEvent(new CustomEvent('show-quick-cookie-consent'));
        document.dispatchEvent(new CustomEvent('hide-cookie-consent'));
      };

      const assignEventListeners = (buttons: (HTMLButtonElement | null)[], eventHandler: () => void) => {
        buttons.forEach((button) => {
          if (button) {
            button.onclick = eventHandler;
          }
        });
      };

      document.addEventListener('consent-status-approved', () => {
        setArtviseClasses();
        assignEventListeners([artviseChatBtn, artviseOnPageChatBtn], onclickArtviseChatEvent);
      });

      const hasConsent = ClientSideStorageService.isConsentGiven(ClientSideStorageType.Functional);

      if (hasConsent) {
        setArtviseClasses();
        assignEventListeners([artviseChatBtn, artviseOnPageChatBtn], onclickArtviseChatEvent);
      } else {
        // Only show chat button when we are NOT at manage cookies page, it should always be hidden there
        if (window.location.href.indexOf('om-cookies') === -1 && window.location.href.indexOf('about-cookies') === -1) {
          setArtviseClasses();
          assignEventListeners([artviseChatBtn, artviseOnPageChatBtn], onClickShowQuickCookieConsent);
        }
      }
    }
  }
}

